<template>
  <div class="fora">
    <div class="topo-header centro">
      <botao-voltar class="voltar" nomeRota="Formularios" />
      <h1>Visualizar Formulário</h1>
    </div>
      <div class="bt-editar" v-if="podeEscrever('formularios')">
        <div class="div-center">
          <div :id="formulario.id">
            <router-link :to="{ name: 'FormularioEdit', params: { id: formulario.id } }" >
              <button id="botao-editar">
                Editar Formulário
              </button>
            </router-link>
          </div>
        </div>
      </div>
    <div class="form centro">
      <div class="dados">
        <fieldset>
          <legend>Dados do Formulário</legend>
          <div class="dados-grid">
            <p class="item">Título do Formulário:
              <span>{{ formulario.titulo }}</span>
            </p>
            <p class="item">Unidade(s):
              <span>{{ getUnidadesFormatadas() }}</span>
            </p>
            <p class="item">Data de início da avaliação:
              <span>{{ formatarData(formulario.data_inicio) }}</span>
            </p>
            <p class="item">Data de término da avaliação:
              <span>{{ formatarData(formulario.data_final) }}</span>
            </p>
            <p class="item">Período Avaliado  - Início:
              <span>{{ formatarData(formulario.data_periodo_inicio) }}</span>
            </p>
            <p class="item">Período Avaliado - Final:
              <span>{{ formatarData(formulario.data_periodo_final) }}</span>
            </p>
            <div class="bt-reaproveitar" v-if="podeEscrever('formularios')">
              <div class="div-center">
                <div :id="formulario.id">
                  <router-link :to="{ name: 'FormularioReaproveitar', params: { id: formulario.id } }" >
                    <button id="botao-reaproveitar">
                      Reaproveitar Formulário
                    </button>
                  </router-link>
                </div>
              </div>
            </div>
          </div>
        </fieldset>
      </div>

      <div class="dados" v-if="formulario.perguntas_formulario && formulario.perguntas_formulario.length > 0">
        <fieldset>
          <legend>Perguntas</legend>
          <div class="perguntas-lista">
            <div v-for="pf in formulario.perguntas_formulario" :key="pf.id" class="pergunta-item">
              <p class="pergunta-titulo"><strong>{{ pf.ordem + 1 }}. {{ pf.pergunta.texto }}</strong></p>
              <p class="pergunta-detalhe">Tipo: <span>{{ formatarTipoPergunta(pf.tipo_pergunta) }}</span></p>

              <div v-if="(pf.tipo_pergunta === 'escolha_unica' || pf.tipo_pergunta === 'multipla_escolha') && pf.alternativas.length > 0">
                
                <p class="alternativas-titulo">Alternativas:</p>
                
                <ul class="alternativas-lista">
                  <li v-for="alternativa in pf.alternativas" :key="alternativa.id" class="alternativa-item">
                    {{ alternativa.resposta.texto }}
                  </li>
                </ul>
              </div>
              </div>
          </div>
        </fieldset>
      </div>
      <div class="bt-editar">
        </div>
    </div>
    <div>
      <Footer
        :createdByLabel="'Criado por'"
        :criadoPor="formulario.criado_por"
        :lastUpdatedByLabel="'Última atualização feita por'"
        :atualizadoPor="formulario.atualizado_por"
        :emLabel="' em '"
        :SistemaLabel="'Sistema'"
        :created_at="formulario.created_at"
        :updated_at="formulario.updated_at"
      />
    </div>
  </div>
</template>

<script>
  // ... (o <script> continua exatamente o mesmo que estava antes, com os methods 'getUnidadeNome' e 'formatarData')
  import BotaoVoltar from "../BotaoVoltar.vue";
  import { parseISO, format } from "date-fns";
  import Footer from "../Footer.vue";
  import UnidadesApi from "../../services/UnidadesApi";

  export default {
    name: "ExibirFormulario",
    props: {
      formulario: Object,
    },
    data() {
      return {
        unidades: [],
      }
    },
    components: {
      BotaoVoltar,
      Footer,
    },
    created() {
      this.unidadeApi = new UnidadesApi();
      this.carregarUnidades();
    },
    methods: {
      async carregarUnidades() {
        try {
          // Busca a lista completa da API
          this.unidades = await this.unidadeApi.getUnidades();
        } catch (err) {
          console.error("Não foi possível carregar a lista de unidades.", err);
        }
      },
      getUnidadeNome(id) {
        // Se a lista ainda não carregou, retorna o ID
        if (!this.unidades || this.unidades.length === 0) {
          return id;
        }
        
        const unidade = this.unidades.find(u => u.id === id);
        
        if (unidade) {
          // Retorna o nome e a sigla (se existir)
          return `${unidade.nome} ${unidade.sigla ? `(${unidade.sigla})` : ''}`;
        }
        
        // Se não encontrar, retorna o ID
        return id;
      },
      formatarData: function (value) {
        if (!value) return '';
        try {
          return format(parseISO(value), "dd/MM/yyyy");
        } catch (error) {
          console.error("Erro ao formatar data:", value, error);
          return "Data inválida";
        }
      },
      formatarTipoPergunta(tipo) {
        if (!tipo) return '';
        
        switch (tipo) {
          case 'escolha_unica':
            return 'Escolha única';
          case 'multipla_escolha':
            return 'Múltipla escolha';
          case 'discursiva':
            return 'Discursiva';
          default:
            // Caso apareça algum tipo novo, só capitaliza
            return tipo.charAt(0).toUpperCase() + tipo.slice(1);
        }
      },
      getUnidadesFormatadas() {
        const form = this.formulario;

        // 1. Se vier uma lista de objetos 'unidades' do backend
        if (form.unidades && form.unidades.length > 0) {
          return form.unidades
            .map(u => `${u.nome} ${u.sigla ? '('+u.sigla+')' : ''}`)
            .join(', ');
        }

        // 2. Se vier uma lista de IDs 'unidade_ids'
        if (form.unidade_ids && form.unidade_ids.length > 0) {
          return form.unidade_ids
            .map(id => this.getUnidadeNome(id))
            .join(', ');
        }

        // 3. Padrão antigo (apenas 1 ID)
        return this.getUnidadeNome(form.id_unidade);
      },
    },
  };
</script>

<style lang="scss" scoped>
  // ... (seus estilos existentes) ...

  /* NOVOS ESTILOS PARA A LISTA DE PERGUNTAS */
  .dados {
    margin-top: 1.5rem;
  }
  .perguntas-lista {
    display: flex;
    flex-direction: column;
    gap: 1.5rem;
  }
  .pergunta-item {
    background-color: #f9f9f9;
    padding: 1rem;
    border-radius: 4px;
    border: 1px solid #eee;
  }
  .pergunta-titulo {
    font-size: 1.1rem;
    margin: 0;
  }
  .pergunta-detalhe {
    font-size: 0.9rem;
    color: #555;
    margin: 0.5rem 0 0 0;
    text-transform: capitalize;
  }
  .pergunta-detalhe span {
    font-weight: bold;
  }
  .alternativas-titulo {
    font-weight: bold;
    font-size: 0.95rem;
    color: #333;
    margin: 1rem 0 0.5rem 1rem; /* Adiciona um espaço e indentação */
  }

  .alternativas-lista {
    list-style-type: disc; /* Adiciona 'bullets' na lista */
    margin: 0.5rem 0 0 2.5rem; /* Indentação da lista */
    padding: 0;
  }

  .alternativa-item {
    font-size: 0.9rem;
    color: #444;
    margin-bottom: 0.5rem; /* Espaço entre os itens */
  }
  // --------- Reaproveitar --------- //
  .bt-reaproveitar {
    text-align: center;
    margin: 1.5rem 0 0 0;
    justify-content: flex-end;
    display: flex;

    button {
      background-color: #005516;
      color: white;
      border: none;
      font-size: 1rem;
      padding: 0.35rem 1.4rem;
      border-radius: 2rem;
      margin: 0.2rem;
    }

    label {
      display: none;
      padding-left: 10px;
      width: 10px;
    }

    #botao-reaproveitar:hover {
      background-color: #4CAF50;
    }

    #botao-reaproveitar-tab:hover {
      background-color: #4CAF50;
    }
  }
  
</style>